---
nb:
  power_plant_responsible:
    delete_confirm_text: Er du sikker på at du vil fjerne denne ansvarlige fra kraftverket? Denne handlingen kan ikke angres.
    delete_confirm_title: Fjern kraftverksansvarlig
  responsible:
    add: Legg til ansvarlig
    already_linked_description: Denne ansvarlige er allerede koblet mot en brukerkonto. Du kan oppdatere navn og telefon, men kan ikke koble fra brukeren.
    already_linked_title: Allerede koblet mot bruker
    auto_switched_description: Vi byttet automatisk til "Koble mot bruker"-modus fordi denne e-posten matcher en eksisterende brukerkonto.
    create_mode_description: Du oppretter en ny ansvarlig person. Fyll ut skjemaet nedenfor og lagre for å opprette den nye personen.
    create_mode_title: Opprett ny ansvarlig
    create_new: Lag ny
    delete_confirm_text: Er du sikker på at du vil slette denne ansvarlige? Denne handlingen kan ikke angres.
    delete_confirm_title: Slett ansvarlig
    deleted_completely: "%{name} har blitt fullstendig fjernet fra systemet."
    deleted_preserved: "%{name} har blitt fjernet fra dette selskapet, men beholdt i systemet på grunn av andre tilkoblinger (varsler, arbeidsoppgaver osv.)."
    edit: Rediger ansvarlig
    edit_mode_description: Du redigerer nå detaljer for ansvarlig person. Fyll ut skjemaet nedenfor og lagre for å oppdatere informasjonen.
    edit_mode_title: Redigeringsmodus aktivert
    edit_plural: Rediger ansvarlige
    edit_power_plant_responsible: Rediger kraftverksansvarlig for
    edit_tooltip: Rediger eller opprett ny ansvarlig person
    email_from_linked_user: E-post fra koblet brukerkonto
    email_match_detected_title: E-post match oppdaget
    link_to_user: Koble mot bruker
    linked_to_user: Koblet mot bruker
    matched_user: 'Matchet bruker:'
    must_have_name_email: Ansvarlige må ha enten navn eller email
    phone_change_warning_description: Endring av dette telefonnummeret vil oppdatere det for den koblede brukerkontoen overalt i systemet.
    phone_change_warning_title: Advarsel om oppdatering av brukertelefon
    phone_from_matched_user: Telefonnummer fra matchet brukerkonto
    responsible: Ansvarlig
    responsibles: Ansvarlige
    role: Rolle
    save_and_link: Lagre og koble til bruker
    select_responsible: Velg ansvarlig person
    task_responsible: Tilgang til oppgavestyring
